var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticStyle:{"padding":"20px"}},[_vm._v(_vm._s(_vm.name)+"'s Gallery - "+_vm._s(_vm.images.length)+" Images")]),(this.images.length>0)?_c('lightbox',{attrs:{"images":_vm.images,"name":this.name}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }